import { render } from "./AccountUpdatePassword.vue?vue&type=template&id=259e4eb4&ts=true"
import script from "./AccountUpdatePassword.vue?vue&type=script&lang=ts"
export * from "./AccountUpdatePassword.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__